<template>
  <div class="sidebar-nav" :class="{'open' : isOpen, 'close' : !isOpen}">
    <div class="sidebar-logo">
      <h2 :class="{'hide-logo' : !isOpen}">Inf<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24">
        <path d="M18.572 6c-6.018 0-8.414 10-13.143 10-2.114 0-3.479-1.578-3.479-4s1.366-4 3.479-4c1.666 0 2.862 1.069 4.017 2.395l1.244-1.561c-1.499-1.533-3.05-2.834-5.261-2.834-3.197 0-5.429 2.455-5.429 6s2.232 6 5.429 6c6.003 0 8.407-10 13.143-10 2.113 0 3.479 1.578 3.479 4s-1.365 4-3.479 4c-1.664 0-2.86-1.068-4.015-2.392l-1.244 1.561c1.499 1.531 3.05 2.831 5.259 2.831 3.197 0 5.428-2.455 5.428-6s-2.231-6-5.428-6z"/>
      </svg>rder</h2>
      <v-btn
        class="ma-0 disable-hover"
        icon
        solo
        color
        :ripple="false"
        small
        @click="toggleSidebar"
      >
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="sidebar-close-btn-icon" :class="{'icon-rotate' : !isOpen}">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z" id="Path-94" fill="#999" fill-rule="nonzero" transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) "></path>
            <path d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z" id="Path-94" fill="#ccc" fill-rule="nonzero" opacity="0.3" transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) "></path>
          </g>
        </svg>
      </v-btn>
    </div>
    <ex-nav></ex-nav>
  </div>
</template>

<script>
import navs from './navs'
export default {
  name: 'ex-sidebar',
  data: () => ({
    timer: 1
  }),
  components: {
    'ex-nav': navs
  },
  methods: {
    toggleSidebar () {
      this.$store.commit('sidebarModule/toggleSidebar')
    }
  },
  computed: {
    isOpen () {
      return this.$store.state.sidebarModule.isOpen
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue